<template>
    <div>
        <password-toggle>
            <input
                id="password"
                name="password"
                type="password"
                class="appearance-none block w-full pl-3 pr-12 py-3 border border-gray-400 rounded-md placeholder-gray-500 focus:outline-none focus:border-green-300 focus:ring focus:ring-green-300 focus:ring-opacity-30 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                placeholder="Contraseña"
                required
                @input="fillPassword($event.target.value)"
                :value="form.password"
            />
        </password-toggle>
        <div class="mt-1">
            <div class="grid md:grid-cols-12 gap-y-px text-gray-500">
                <div class="md:col-span-6 lg:col-span-4">
                    <p class="inline text-xs">
                        <span
                            :class="{
                                'text-green-500': passwordValidator.isLongEnough,
                                'text-red-500': form.password.length > 0 && !passwordValidator.isLongEnough,
                            }"
                            >●</span
                        >
                        Mínimo 8 caracteres
                    </p>
                </div>
                <div class="md:col-span-6 lg:col-span-5">
                    <p class="inline text-xs">
                        <span
                            :class="{
                                'text-green-500': passwordValidator.isUpperAndLowercase,
                                'text-red-500': form.password.length > 0 && !passwordValidator.isUpperAndLowercase,
                            }"
                            >●</span
                        >
                        Utiliza una letra mayúscula
                    </p>
                </div>
                <div class="md:col-span-6 lg:col-span-3">
                    <p class="inline text-xs">
                        <span
                            :class="{
                                'text-green-500': passwordValidator.hasANumber,
                                'text-red-500': form.password.length > 0 && !passwordValidator.hasANumber,
                            }"
                            >●</span
                        >
                        Utiliza un número
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PasswordValidator from '../support/PasswordValidator';
import PasswordToggle from './PasswordToggle';

export default {
    data: () => ({
        form: {
            password: '',
        },
        passwordValidator: new PasswordValidator(),
    }),
    methods: {
        fillPassword(password) {
            this.form.password = password;
            this.passwordValidator.run(this.form.password);
        },
    },
    components: {
        PasswordToggle,
    },
};
</script>
